import { render, staticRenderFns } from "./lista-buscador.vue?vue&type=template&id=775b2643&scoped=true&"
import script from "./lista-buscador.vue?vue&type=script&lang=ts&"
export * from "./lista-buscador.vue?vue&type=script&lang=ts&"
import style0 from "./lista-buscador.vue?vue&type=style&index=0&id=775b2643&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775b2643",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDivider,VIcon,VRow,VSpacer,VTextField})
